import {
  CollectionBreadcrumb,
  GoBackLink,
  HeroCollection,
  LastOrders,
} from '@screens/Collection/components';
import ScrollToTop from '@components/ScrollToTop';
import { useTranslations } from 'next-intl';

export const CollectionReorder = () => {
  const tAccount = useTranslations('Account');

  return (
    <div className="limited-width-container tw-flex tw-flex-col">
      <div className="tw-px-4 tw-py-3 desktop:tw-hidden">
        <GoBackLink currentPathTitle={tAccount('reorder')} />
        <p className="title-xs tw-pb-2 tw-pt-3">{tAccount('reorder')}</p>
      </div>
      <div className="tw-mb-6 tw-mt-4 tw-hidden desktop:tw-block">
        <CollectionBreadcrumb currentPathTitle={tAccount('reorder')} />
      </div>
      <div className="tw-order-2 tw-flex tw-justify-center tw-py-6 tw-text-center desktop:tw-hidden">
        <ScrollToTop />
      </div>
      <div className="tw-order-1 tw-mt-6 desktop:tw-order-none desktop:tw-mt-0">
        <HeroCollection
          title={tAccount('reorder')}
          descriptionHtml={`<p>${tAccount('reorderInOneClick')}</p>`}
        />
      </div>
      <div className="desktop:tw-my-6">
        <LastOrders />
      </div>
    </div>
  );
};
